import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
const en = {
  // 登录页
  login: {
    title: 'User login',
    username: 'Username',
    password: 'Password',
    verify_code: 'Verification Code',
    btn: 'Login',

    header_title: 'What is an overseas marketing resource',
    header_content: 'Up to now, the company`s products have covered more than 150 countries and regions, 75 languages, in more than 40 countries and regions ranked in the top of the total list of app stores, through the products to help you connect with international users, accurately push your advertising information, to meet your overseas promotion needs',
    header_desc: 'Information Promotion Overseas',

    item1_title: 'Huge number of users',
    item1_content: 'Coverage, more than 150 countries and regions<br />Top 40 national app stores',
    item2_title: 'Native Immersion',
    item2_content: 'Premium content, native delivery,seamlessly integrated into regular content recommendation streams',
    item3_title: 'Effect visible',
    item3_content: 'Real-time display of multi-dimensional data，<br />Your good marketing helper',
    item4_title: 'Good traffic',
    item4_content: 'Based on Douyin platform, high quality user flow，<br />Then upgrade the crowd portrait orientation',

    username_verify: 'User name cannot be empty',
    password_verify: 'Password cannot be empty',
    code_verify: 'The verification code is wrong',
    code_null: 'Verification code cannot be empty'
  },

  // 公共部分
  common: {
    website: 'Tiktok advertising',
    nav1: 'Home page',
    nav2: 'Promotion',
    nav2_1: 'Advertising Plan',
    nav2_2: 'Advertising Group',
    nav2_3: 'Advertising',
    nav3: 'Report',
    nav4: 'Bill',
    nav5: 'Account center',
    user_center: 'Personal center',
    exit_system: 'Exit system',
    empty_text: 'Temporarily no data',
    layer_btn_cancel: 'Cancel',
    layer_btn_sure: 'Confirm'
  },

  // 首页
  index: {
    title: 'Data trends',
    select_font: 'All',
    btn_1: 'Consumption（yuan）',
    btn_2: 'Display（times）',
    btn_3: 'Click（times）',
    hello: 'Hello ',
    pass: 'Pass',
    balance: 'Promotional Balance',
    good: 'Compliance credit score',
    product_title1: 'Stream promotion',
    product_title1_1: 'Total daily budget(yuan)',
    product_btn1: 'Enter',
    product_title2: 'Thdudbui promotion',
    product_content2: 'ThDudbui promotion triggers industry-specific search results by accurately identifying users` search needs and intentions。',
    product_btn2: 'Not claimable',
    product_title3: 'Knowledge marketing',
    product_content3: 'Knowledge marketing answers questions of Internet users directly to relevant needs, deeply influences consumption decisions, and forms synergies between brand and content marketing in the long term。',

    layer_title: 'Change account budget',
    layer_form_title1: 'Budget',
    layer_form_btn1: 'Unlimited budget',
    layer_form_btn2: 'Specify',
    layer_form_title2: 'Specify',
    layer_form_desc2: 'Budget set 0 is suspended',
    budget_title: 'Unlimited budget',
  },

  // 报表
  report: {
    title: 'Effect data',
    condition1: 'Time',
    condition2: 'Advertising Plan',
    condition3: 'Advertising Group',
    condition4: 'Advertisement',
    condition_label: 'no limits',
    options1: 'Number of hits',
    options2: 'Show number',
    options3: 'Consume（yuan）',
    search_btn: 'Query',
    item1: 'Exposure（次）',
    item2: 'Click count（次）',
    item3: 'Click Rate',
    item4: 'Average（yuan）',
    item5: 'Consumption（yuan）',
    td1: 'Time',
    td2: 'Show number',
    td3: 'Number of hits',
    td4: 'Click Rate',
    td5: 'Consume(yuan)'
  },

  // 账单
  bill: {
    title: 'Bill ',
  	balance: 'My balance ',
  	freeze_money: 'Frozen amount (yuan)',
  	condition1: 'Date ',
  	condition2: 'Type ',
  	condition_label: 'No limits ',
  	search_btn: 'Query ',
  	td1: 'Company email ',
  	td2: 'Company name ',
  	td3: 'Date ',
  	td4: 'Type ',
  	td5: 'Amount (Yuan)',
  	td6: 'Transaction number ',
  	td7: 'Remarks ',
  	type1: 'Account recharge ',
  	type2: 'Consumption ',
  },

  // 账户中心
  user: {
  	title: 'Account Center ',
  	default_title1: 'Basic information ',
  	line1: 'Agent ID: ',
  	line2: 'Company Name: ',
  	line3: 'Mailing address: ',
  	line4: 'Website Link: ',
  	line5: 'Product Name: ',
  	line6: 'Contact Name: ',
  	line7: 'Contact Number: ',
  	line8: 'Business License No. : ',
  	default_title2: 'account qualification ',
  	label1: 'Business License ',
  	label2: 'ICP Qualification Filing ',
  	td1: 'Uniform Social Credit Code for Business License ',
  	td2: 'Qualification Expiration Date'
  },

  // 广告列表页
  adv: {
    plan_title: 'Advertising series',
    group_title: 'Advertising Group',
    adv_title: 'Advertisement',
    click: 'Number of hits',
    read: 'Display number',
    pay: 'Consumption (yuan)',
    condition: 'All time',
    icon_type: 'Chart type',
    add_title: 'Add ad series',
    add_title_group: 'Add ad group',
    add_title_adv: 'Add ads',
    verify: 'Advertising series status: account verified',
    verify_group: 'Advertising group status: account verified',
    verify_adv: 'Advertising status: account verified',
    sum_text: 'Summary',
    search: 'Search',
    show: 'Show',
    shopping: 'Shopping',
    video: 'Video',
    ai: 'Intelligence',
    find: 'Find',
    edit_plan_title1: 'Modify advertising series name',
    edit_plan_title2: 'Modify advertising series budget',
    old_plan_title1: 'Original advertising plan name',
    new_plan_title1: 'New advertising series name',
    old_plan_title2: 'Original advertising series budget',
    new_plan_title2: 'New advertising series budget',
    edit_group_title1: 'Modify ad group name',
    edit_group_title2: 'Select an advertising series',
    old_group_title1: 'Original advertising group name',
    new_group_title1: 'New advertising group name',
    adv_video_label: 'Video demo',
    edit_adv_title1: 'Modify the advertisement name',
    edit_adv_title2: 'Select an advertising group',
    old_adv_title1: 'Original advertisement name',
    new_adv_title1: 'New advertising name',
    td_index: 'Switch',
    td_edit: 'Edit',
    td_delete: 'Delete',
    td_doing: 'operation',
    td_state: 'State',
    state_start: 'Start',
    state_stop: 'Pause',
    td_plan: 'Advertising Series',
    td_group: 'Advertising Group',
    td_adv: 'Advertising',
    td_video: 'View video',
    td1: 'Budget',
    td2: 'Advertising series type',
    td3: 'Display times',
    td4: 'Click through rate',
    td5: 'Fees',
    td6: 'Bidding strategy type',
    td7: 'Number of hits',
    td8: 'Conversion rate',
    td9: 'Conversion times',
    td10: 'Average cost per click',
    td11: 'Cost per conversion',
    td12: 'Strive for more clicks as much as possible',
    td13: 'Ad group type',
    td14: 'Standard',
    td15: 'Dynamic',
    td16: 'Advertisement type'
  },


  // 新增广告公共
  adv_common: {
    first: 'Advertising series settings',
    second: 'Set ad group',
    third: 'Set advertisement',
    end: 'Finish',
    save_btn1: 'Save and continue',
    save_btn2: 'Save',
    next: 'Continue'
  },

  // 新建广告系列
  create_plan: {
    target_title: 'Please choose the goal you want to achieve. As long as you achieve this goal, the advertising series will achieve the ideal effect for you',
    target1: 'Sales',
    target2: 'Potential customers',
    target3: 'Website traffic',
    target4: 'Product and brand preference',
    target5: 'Brand awareness and coverage',
    target6: 'Application promotion',
    target7: 'Patronage and promotion of local physical stores',
    target8: 'Create an advertising series without goal orientation',
    plan_title: 'Select the type of advertising series',
    plan1: 'Show text ads to customers who are interested in your products or services',
    plan2: 'Put all kinds of advertisements on the whole network',
    plan3: 'Advertise your products by placing shopping ads',
    plan4: 'Cover tiktok and video viewers on the whole network to attract them to interact with advertisements',
    plan5: 'Help you achieve your business goals by placing automatically generated ads in tiktok and throughout the network',
    plan6: 'Advertise in tiktok exploration and more high-quality advertising spaces',
    type_title: 'Choose how you want to achieve your goal',
    type1: 'Site visits',
    type2: 'Number of calls',
    type3: 'App download',
    default_set: 'General settings',
    type: 'Type:',
    target: 'Target:',
    title: 'Advertising series name',
    title_p: 'Please enter the name of the advertising series',
    network: 'Launch network',
    network_desc: 'Including tiktok search network partners',
    network_title: 'Display advertising network',
    network_content: 'If users search for words related to keywords, advertisements will be displayed next to tiktok search results and on other tiktok websites',
    date: 'Start date and end date',
    date_s: 'Start date ',
    date_e: 'End date',
    date_p: 'Select date ',
    date_desc1: 'Unless the end date is specified,',
    date_desc2: 'Otherwise, your advertisement will continue to be launched. ',
    set_title: 'Dynamic search advertising settings',
    set_title1: 'Enter title',
    set_title_p: 'Please enter the title',
    set_desc: 'Choose the language of search ads',
    set_options: 'Please select',
    set_position: 'Select location source',
    set_options1: 'Index my website using tiktok',
    set_options2: 'Use only the URL from my page feed',
    set_options3: 'Use both the URL in the index compiled by tiktok for my website and the URL in my page feed',
    font: 'Dynamic search ads (DSA)',
    font_content1: 'The relevant search will be automatically located according to the content on your website',
    font_content2: 'And then use the title automatically customized according to the users actual search content.',
    font_content3: 'This setting is used to determine which domain to use for your dynamic search advertisement',
    font_content4: 'Language and location source. To create dynamic search ads, ',
    font_content5: 'You need to create a dynamic ad group in the next step. ',
    time: 'Advertising time',
    time_content: 'All day',
    position_title: 'Positioning and audience groups',
    position_title2: 'Select the audience you want to cover',
    position: 'Geographical location',
    position_desc: 'Select the location to locate',
    country: 'All countries and regions',
    china: 'China',
    other: 'Enter other geographic location',
    other_p: 'Please enter geographic location',
    other_desc: 'For example, country / region, city, region or postcode',
    languare: 'Language',
    languare_title: 'Select the language used by the target user',
    languare_title2: 'Show language customers. ',
    languare_p: 'Try search: Guide ',
    languare_desc1: 'To show advertisements to users <br /> whose language preference is set to Spanish',
    languare_desc2: 'Please choose Spanish as your advertising <br /> language and use Spanish advertising text and keywords',
    price1: 'Budget and bid',
    price2: 'Specify how much you want to spend and how you want to spend it',
    price_title: 'Budget',
    price_title2: 'Enter the average amount you want to spend per day',
    price_title_p: 'Please enter the amount',
    group_price: 'Group bid',
    group_price_p: 'Please enter group bid',
    price_desc1: 'Your monthly actual expenditure will not <br /> exceed the product of daily budget and the average <br /> number of days in a month. ',
    price_desc2: 'The actual expenditure on some days may <br /> be lower than the daily budget',
    price_desc3: 'On some days, the actual expenditure <br />may be at most twice the daily budget. ',
    pay: 'Bid',
    pay_title: 'What do you want to focus on? ',
    pay_desc: 'Recommended options for your ad series',
    num: 'Conversion times',
    num_title: 'Please select which conversions will be included in the "conversion times" column of this advertising series for smart bidding',
    num_option1: 'Use the account level "include in the" conversion times "column" setting',
    num_option2: 'Select the conversion operation for this ad series',
    banner: 'Advertising rotation',
    banner1: 'Optimization: give priority to the best ads',
    banner2: 'No optimization: unlimited round robin ads',
    banner3: 'Optimize for transformation (not supported)',
    banner4: 'Uniform carousel (not supported)',
    plan_desc: 'Advertising plan',
    target_verify: 'Please select a target',
    type_verify: 'Please select a type',
    title_verify: 'Advertising series name cannot be empty',
    budget_verify: 'Budget cannot be empty',
    group_price_verify: 'Group bid cannot be empty',
    price_type1: 'Recommended',
    price_type2: 'Conversion times',
    price_type3: 'Conversion value',
    price_type4: 'Other optimization options',
    price_type5: 'Number of clicks',
    price_type6: 'Display times share',
  },

  // 语言
  languare: {
    a1: 'Arabic',
    a2: 'Bulgarian',
    a3: 'Czech',
    a4: 'Danish',
    a5: 'German',
    a6: 'Modern Greek',
    a7: 'English',
    a8: 'Spanish',
    a9: 'Estonian',
    a10: 'Persian',
    a11: 'Finnish',
    a12: 'French',
    a13: 'Croatian',
    a14: 'Hungarian',
    a15: 'Italian',
    a16: 'Lithuanian',
    a17: 'Latvian',
    a18: 'Norwegian',
    a19: 'Dutch',
    a20: 'Polish',
    a21: 'Portuguese',
    a22: 'Romanian',
    a23: 'Russian',
    a24: 'Slovak',
    a25: 'Slovenian',
    a26: 'Serb',
    a27: 'Swedish',
    a28: 'Turkish',
    a29: 'Ukrainian',
    a30: 'Chinese'
  },

  // 新建广告组
  create_group: {
    title: 'Set ad group',
    desc: 'An ad group contains one or more ads and a set of related keywords. For best results, try to focus all the ads and keywords in an ad group on one product or service. ',
    group: 'Advertising Group',
    group_name: 'Advertising group name',
    group_name_p: 'Please enter advertising group name',
    keyword: 'Keyword',
    keyword_desc: 'Find relevant keywords by describing the advertising objects in this advertising group',
    url: 'Please enter the relevant webpage address',
    url_title: 'Please enter the relevant page title',
    keyword_title: 'A keyword is a word or phrase that is used to connect your advertisement with the words searched by users',
    keyword_line: 'Enter or paste your keywords, one word or phrase per line',
    group_name_verify: 'Advertising group name cannot be empty',
    url_verify: 'Advertising group link cannot be empty',
    url_title_verify: 'Ad group link Title cannot be empty',
    content_verify: 'Keyword of advertising group cannot be empty'
  },

  // 新建广告
  create_adv: {
    title: 'Making advertisements',
    desc: 'It is suggested that you make an adaptive search advertisement with at least "good" advertising effect for each advertising group, and the advertising content should be closely related to the theme of the keyword. ',
    group_name: 'Advertising group:',
    keyword: 'Keyword:',
    keyword_desc: 'Compared with making multiple text ads, making an adaptive search ad can bring better results. ',
    title2: 'When using adaptive search advertisement, you need to enter multiple titles and multiple descriptions of advertisement content. Tiktok will then incorporate them into the ad. ',
    url: 'Please enter the link',
    name: 'Title',
    name_p: 'New title',
    upload: 'Upload video',
    upload_btn: 'Browse...',
    right_title: 'Advertising effectiveness',
    state: 'Good',
    right_keyword: 'Try to include more keywords in the title',
    keyword1: 'Add more titles',
    keyword2: 'Include popular keywords in the title',
    keyword3: 'Make your title more unique',
    keyword4: 'Make your advertising content more unique',
    look: 'Preview',
    look_content: 'This preview screen shows what kind of advertisement you may make by using your material resources. Not all combinations will show up. Material resources may be presented in any order, so please make sure that they work individually or in combination and do not violate our policy or local laws. In some advertising formats, there may be a certain degree of omission. You can make sure that some text is always displayed in the advertisement. ',
    create: 'New',
    edit: 'Modify',
    adv: 'Advertising',
    url_verify: 'Link cannot be empty',
    title_verify: 'Title cannot be empty',
    video_verify: 'Please upload video',
    video_type: 'Please upload correct video format',
    video_size: 'Video size cannot exceed 100MB',
    success: 'Operation successful'
  },

  ...enLocale
}

export default en;
